/* Oji Matcha — Collection editorial: variant pills + smart add-to-cart.
   Vanilla JS, no jQuery. Integrates with Ella's sidebar cart via its
   global hooks; falls back to a /cart redirect when they're absent. */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  /* Theme-wide convention: prefix ajax URLs with window.routes.root for
     multi-market subfolder compatibility (empty string on default market,
     set in snippets/global-script.liquid, no trailing slash). */
  function root() {
    return (window.routes && window.routes.root) || '';
  }

  /* innerHTML does not execute <script> tags (jQuery's .html() does, and
     the ajax_side_cart fragment relies on them: quantity popover loader,
     per-item inventory globals, popup re-parenting). Re-create each script
     node so the fragment behaves the same as Ella's own injection. */
  function runInjectedScripts(container) {
    container.querySelectorAll('script').forEach(function (old) {
      var script = document.createElement('script');
      if (old.src) {
        script.src = old.src;
        if (old.defer) script.defer = true;
      } else {
        script.textContent = old.textContent;
      }
      old.parentNode.replaceChild(script, old);
    });
  }

  /* Ella's `halo` object lives inside theme.js's IIFE (not on window), so we
     replicate its updateSidebarCart flow with the same public endpoints:
     GET /cart?view=ajax_side_cart -> inject into the sidebar wrapper, then
     refresh the count bubbles from /cart.js. Returns false when the sidebar
     container isn't in the DOM (caller falls back to a /cart redirect). */
  function openSidebarCart() {
    var wrapper = document.querySelector('#halo-cart-sidebar .halo-sidebar-wrapper .previewCart-wrapper');
    if (!wrapper) return false;
    document.body.classList.add('cart-sidebar-show');
    fetch(root() + '/cart?view=ajax_side_cart', { headers: { Accept: 'text/html' }, cache: 'no-store' })
      .then(function (r) {
        if (!r.ok) throw new Error('side cart view failed: ' + r.status);
        return r.text();
      })
      .then(function (html) {
        wrapper.innerHTML = html;
        runInjectedScripts(wrapper);
        return fetch(root() + '/cart.js', { headers: { Accept: 'application/json' } });
      })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
        /* Port of halo.dispatchChangeForShippingMessage (theme.js): the
           <free-shipping-component> bar lives OUTSIDE the repainted wrapper
           and only recalculates on a 'change' event. */
        document.querySelectorAll('[data-free-shipping-wrapper]').forEach(function (el) {
          el.dispatchEvent(new Event('change', { bubbles: true }));
        });
      })
      .catch(function () {
        /* content refresh is best-effort; the sidebar is already open */
      });
    return true;
  }

  function initBlock(block, strings) {
    var dataEl = block.querySelector('[data-variant-data]');
    var addBtn = block.querySelector('[data-add-button]');
    if (!dataEl || !addBtn) return;

    var variants;
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (err) {
      return;
    }
    if (!Array.isArray(variants) || !variants.length) return;

    var priceEl = block.querySelector('[data-price]');
    var compareEl = block.querySelector('[data-compare-price]');
    var imgEl = block.querySelector('[data-main-image]');
    var labelEl = block.querySelector('[data-add-label]');
    var feedbackEl = block.querySelector('[data-feedback]');
    var idleLabel = labelEl ? labelEl.textContent : '';

    function findVariant(id) {
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].id === id) return variants[i];
      }
      return null;
    }

    var checkedInput = block.querySelector('[data-variant-picker] input:checked');
    var current = checkedInput ? findVariant(Number(checkedInput.value)) : variants[0];

    function select(variant) {
      if (!variant) return;
      current = variant;
      if (priceEl) priceEl.textContent = variant.price;
      if (compareEl) {
        compareEl.hidden = !variant.compare;
        compareEl.textContent = variant.compare || '';
      }
      if (imgEl && variant.image) {
        imgEl.src = variant.image;
        imgEl.removeAttribute('srcset');
      }
      addBtn.disabled = !variant.available;
      if (labelEl) labelEl.textContent = variant.available ? idleLabel : strings.soldOut;
    }

    block.querySelectorAll('[data-variant-picker] input').forEach(function (input) {
      input.addEventListener('change', function () {
        select(findVariant(Number(input.value)));
      });
    });

    addBtn.addEventListener('click', function () {
      if (!current || !current.available || addBtn.classList.contains('is-loading')) return;
      addBtn.classList.add('is-loading');
      if (labelEl) labelEl.textContent = strings.adding;
      if (feedbackEl) feedbackEl.textContent = '';

      fetch(root() + '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: current.id, quantity: 1 }] })
      })
        .then(function (r) {
          if (!r.ok) {
            return r.json().catch(function () { return {}; }).then(function (err) {
              throw new Error(err.description || strings.error);
            });
          }
          if (labelEl) labelEl.textContent = idleLabel;
          if (feedbackEl) feedbackEl.textContent = strings.added;
          if (!openSidebarCart()) window.location.href = root() + '/cart';
        })
        .catch(function (err) {
          if (labelEl) labelEl.textContent = idleLabel;
          if (feedbackEl) feedbackEl.textContent = err.message || strings.error;
        })
        .finally(function () {
          addBtn.classList.remove('is-loading');
        });
    });
  }

  ready(function () {
    var rootEl = document.querySelector('.oji-editorial');
    if (!rootEl) return;
    var strings = {
      adding: rootEl.getAttribute('data-str-adding') || '',
      added: rootEl.getAttribute('data-str-added') || '',
      error: rootEl.getAttribute('data-str-error') || '',
      soldOut: rootEl.getAttribute('data-str-soldout') || ''
    };
    rootEl.querySelectorAll('[data-product-block]').forEach(function (block) {
      initBlock(block, strings);
    });
  });
})();
